if (!customElements.get('countdown-banner')) {
  customElements.define(
    'countdown-banner',
    class CountdownBanner extends HTMLElement {
      connectedCallback() {
        if (this.intervalId) return;

        this.endAt = new Date(this.dataset.endAt).getTime();
        this.values = {
          days: this.querySelector('[data-countdown-value="days"]'),
          hours: this.querySelector('[data-countdown-value="hours"]'),
          minutes: this.querySelector('[data-countdown-value="minutes"]'),
          seconds: this.querySelector('[data-countdown-value="seconds"]')
        };

        if (!Number.isFinite(this.endAt) || Object.values(this.values).some((value) => !value)) {
          this.hidden = true;
          return;
        }

        this.update();
        if (!this.hidden) this.intervalId = window.setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        this.stop();
      }

      stop() {
        if (!this.intervalId) return;
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }

      update() {
        const remaining = this.endAt - Date.now();

        if (remaining <= 0) {
          this.complete();
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        this.values.days.textContent = String(days).padStart(2, '0');
        this.values.hours.textContent = String(hours).padStart(2, '0');
        this.values.minutes.textContent = String(minutes).padStart(2, '0');
        this.values.seconds.textContent = String(seconds).padStart(2, '0');
      }

      complete() {
        this.stop();

        if (this.dataset.hideOnComplete === 'true') {
          this.hidden = true;
          return;
        }

        Object.values(this.values).forEach((value) => {
          value.textContent = '00';
        });

        const heading = this.querySelector('.countdown-banner__heading');
        if (heading && this.dataset.expiredMessage) heading.textContent = this.dataset.expiredMessage;
      }
    }
  );
}
